// src/pages/ProjectListPage.js
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Project.css";

const API_BASE = process.env.REACT_APP_API_BASE_URL || "";

export default function ProjectListPage() {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [search, setSearch] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    loadProjects();
  }, []);

  async function loadProjects() {
    setLoading(true);
    setError("");
    try {
      const token = localStorage.getItem("authToken");
      const res = await fetch(`${API_BASE}/api/projects/`, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });

      if (!res.ok) {
        let msg = `HTTP ${res.status}`;
        try {
          const data = await res.json();
          if (data && data.detail) {
            msg = data.detail;
          }
        } catch (e) {}
        throw new Error(msg);
      }

      const text = await res.text();
      const data = text ? JSON.parse(text) : null;
      setProjects(data || []);
    } catch (e) {
      setError(e.message || "프로젝트를 불러오지 못했습니다.");
    } finally {
      setLoading(false);
    }
  }

  const filtered = projects.filter((p) => {
    if (!search.trim()) return true;
    const q = search.toLowerCase();
    return (
      (p.name || "").toLowerCase().includes(q) ||
      (p.version || "").toLowerCase().includes(q) ||
      (p.description || "").toLowerCase().includes(q)
    );
  });

  function handleRowClick(id) {
    navigate(`/projects/${id}`);
  }

  return (
    <div className="project-page">
      <div className="project-header">
        <h1>프로젝트 관리</h1>
        <div className="project-header-right">
          <input
            className="project-search-input"
            placeholder="이름 / 버전 / 설명 검색"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          {/* 향후: 프로젝트 추가 버튼, 필터 등 */}
        </div>
      </div>

      {loading && (
        <div className="project-loading">프로젝트 목록을 불러오는 중...</div>
      )}
      {error && <div className="project-error">{error}</div>}

      {!loading && !error && (
        <table className="project-table">
          <thead>
            <tr>
              <th>이름</th>
              <th>버전</th>
              <th>BOM 개수</th>
              <th>BOM 합계</th>
              <th>생성일</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((p) => (
              <tr
                key={p.id}
                className="project-row"
                onClick={() => handleRowClick(p.id)}
              >
                <td>{p.name}</td>
                <td>{p.version || "-"}</td>
                <td>{p.bom_count}</td>
                <td>{p.total_bom_cost}</td>
                <td>{new Date(p.created_at).toLocaleString()}</td>
              </tr>
            ))}
            {filtered.length === 0 && (
              <tr>
                <td colSpan={5} className="project-empty">
                  프로젝트가 없습니다.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}
    </div>
  );
}
